import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Componentes
import Button from '@mui/material/Button';
import TableComponent from '../../../TableComponent';
import ExportExcel from '../../../DownloadExcel';

// Styles
import styles from '../index.module.sass';

const country = process.env.REACT_APP_COUNTRY;

const Prebranch = (props) => {
  const {
    prebranch,
    screenSize,
    getBranchInfo,
    yearSelected,
    setYearSelected,
    monthSelected,
    setMonthSelected,
    yearBase,
  } = props;
  const {
    listaGC = [],
    listaPatrocinando = [],
    listaPorPerder = [],
    preBranch = [],
    listaPorReactivarRetener = [],
  } = prebranch;
  const { t } = useTranslation(['global', 'branch']);
  const [infoType, setInfoType] = useState('GENERAL');

  console.log(listaPorReactivarRetener);

  const months = t('global:months', { returnObjects: true });

  const preItems = t(
    (infoType === 'GENERAL' && 'branch:prebranch') ||
      (infoType === 'LIST' && `${country === 'MX' ? 'branch:listMX' : 'branch:listUS'}`) ||
      (infoType === 'SPONSORING' && 'branch:sponsoring') ||
      (infoType === 'LOSING' && 'branch:losing') ||
      (infoType === 'REACTIVATE' && 'branch:toReactivate'),
    { returnObjects: true },
  );

  const infoArray =
    (infoType === 'GENERAL' && preBranch) ||
    (infoType === 'LIST' && listaGC) ||
    (infoType === 'SPONSORING' && listaPatrocinando) ||
    (infoType === 'LOSING' && listaPorPerder) ||
    (infoType === 'REACTIVATE' && listaPorReactivarRetener);

  const handleChange = (type) => {
    setInfoType(type);
  };

  const handleDateChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'month') {
      setMonthSelected(value);
      getBranchInfo(yearSelected, value);
    }
    if (name === 'year') {
      setYearSelected(value);
      getBranchInfo(value, monthSelected);
    }
  };

  return (
    <div className={styles.optionContainer}>
      <div className={styles.dateSelect}>
        <span className={styles.instructions}>{t('branch:instructions')}</span>
        <div className={styles.selectCombo}>
          <div className={styles.selectContainer}>
            <select
              className={styles.inputSelect}
              value={monthSelected}
              name='month'
              onChange={handleDateChange}>
              {months.map((val, key) => {
                return (
                  <option key={key} value={key + 1}>
                    {key + 1}
                  </option>
                );
              })}
            </select>
          </div>

          <div className={styles.selectContainer}>
            <select
              className={styles.inputSelect}
              value={yearSelected}
              name='year'
              onChange={handleDateChange}>
              <option value={yearBase - 1}>{yearBase - 1}</option>
              <option value={yearBase}>{yearBase}</option>
              <option value={yearBase + 1}>{yearBase + 1}</option>
            </select>
          </div>
        </div>
      </div>
      <div className={styles.preButtonsContainer}>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.buttonPre} ${styles[infoType === 'GENERAL']} ${
            styles.prebranchButton
          }`}
          onClick={(e) => handleChange('GENERAL')}>
          {t('branch:generalButton')}
        </Button>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.buttonPre} ${styles[infoType === 'LIST']} ${styles.prebranchButton}`}
          onClick={(e) => handleChange('LIST')}>
          {t('branch:ListButton')}
        </Button>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.buttonPre} ${styles[infoType === 'SPONSORING']} ${
            styles.prebranchButton
          }`}
          onClick={(e) => handleChange('SPONSORING')}>
          {t('branch:sponsoringButton')}
        </Button>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.buttonPre} ${styles[infoType === 'LOSING']} ${
            styles.prebranchButton
          }`}
          onClick={(e) => handleChange('LOSING')}>
          {t('branch:losingButton')}
        </Button>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.buttonPre} ${styles[infoType === 'REACTIVATE']} ${
            styles.prebranchButton
          }`}
          onClick={(e) => handleChange('REACTIVATE')}>
          {t('branch:reactivateButton')}
        </Button>
      </div>
      <ExportExcel tableData={infoArray} infoType={infoType} tableItems={preItems} />
      <TableComponent screenSize={screenSize} tableData={infoArray} tableItems={preItems} />
    </div>
  );
};

export default Prebranch;
